export default __webpack_public_path__ + "static/media/summerchallenge09.5a233182.gif";